import React, { useEffect, useState } from "react";
import { genericFetchData } from "../../../Services/Service";
import { getUserCode } from "../../../Storage/Datastore";

export default function useInsurance() {
  const [page, setPage] = useState(0);
  const [states, setStates] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [modal, setModal] = useState({ isOpen: false });
  const [insurances, setInsurances] = useState([]);

  useEffect(() => {
    getInsuranceData();
  }, [page]);

  const getInsuranceData = async () => {
    const pageNo = page ? page - 1 : page;
    const response = await genericFetchData(
      `/insurance/all?pageNo=${pageNo}&pageSize=10`,
      "GET"
    );
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      const mappedData = responseData?.insurances?.map((val) => {
        return {
          id: val?.insuranceId,
          cellItem1: val?.insuranceName,
          cellItem2: val?.contactName,
          cellItem3: val?.contactNumber,
          cellItem4: val?.approved,
        };
      });

      let res = { count: responseData?.count, insurances: mappedData };
      setInsurances(res);
    }
    console.log("=======error", status);
  };

  const deleteInsurance = async (id) => {
    const userCode = getUserCode();
    const response = await genericFetchData(
      `/insurance/delete/${id}?userCode=${userCode}`,
      "DELETE"
    );
    const status = response.status;
    if (status == 200) {
      getInsuranceData();
    }
  };

  const save = async (postData, id) => {
    if (id) {
      postData.insuranceId = id;
    }
    const response = await genericFetchData(
      `/insurance/save`,
      "POST",
      postData
    );
    const status = response.status;
    if (status == 200) {
      getInsuranceData();
    }
    console.log("=======error", status);
  };

  const addNew = {
    type: "INSURANCE",
    save: save,
    buttons: [
      { id: 1, buttonName: "Cancel" },
      { id: 2, buttonName: "Add" },
    ],
  };

  const deleteTableCell = (cellId) => {
    const cellItem = insurances?.insurances?.filter(
      (item) => item.id !== cellId
    );
    setInsurances(cellItem);
    deleteInsurance(cellId);
  };

  const deleteBoxData = {
    type: "DELETE",
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
    deleteData: deleteTableCell,
  };

  const handleOpenPopup = async (data) => {
    setModal({ isOpen: true, data: data });
  };

  const handleOpenEditPopUp = (data) => {
    console.log("data======================", data);
    const combineData = { ...addNew, value: data };
    handleOpenPopup(combineData);
  };

  const handleCheckboxChange = (checked, index) => {
    console.log("index=====================", index);
    const approvedData = { approved: checked, insuranceId: index };
    const approvedItem = insurances?.insurances?.map((item) =>
      item.id === index ? { ...item, cellItem4: checked } : item
    );
    setCheckedItems(approvedItem);
    save(approvedData);
  };

  const handleApprovePopup = (event, index) => {
    console.log("index=====================", index);
    approveData.checked = event.target.checked;
    approveData.index = index;
    setModal({ isOpen: true, data: approveData });
  };

  const handleDelete = (cellId) => {
    deleteBoxData.deletedId = cellId;
    setModal({ isOpen: true, data: deleteBoxData });
  };

  const approveData = {
    type: "APPROVE",
    handleApprove: handleCheckboxChange,
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
  };

  return {
    insurances,
    setInsurances,
    modal,
    setModal,
    handleOpenPopup,
    addNew,
    handleOpenEditPopUp,
    handleDelete,
    handleApprovePopup,
    setPage,
    page,
  };
}
